<script setup>
import PrimaryButton from "../../../../frontend/src/components/ui/PrimaryButton.vue";
import {computed, onMounted, reactive, ref, watch} from "vue";
import useForm from "@/composables/useForm";
import corporatesService from "@/services/corporates.service";
import {useStore} from "vue2-helpers/vuex";
import VueMultiselect from "vue-multiselect";

const emit = defineEmits(['saved']);
const store = useStore();

const form = reactive({
    subsectorsIds: [],
    llm: "gpt-4o",
})

const selectCategories = ref(false);

const subsectors = ref([]);

const {resetForm} = useForm(form);
const showModal = ref(false);
const id = ref(null);
const loading = ref(false);

const canSync = computed(() => form.subsectorsIds.length || !selectCategories.value);

watch(subsectors, (value) => {
    form.subsectorsIds = value.map(item => item.id);
});

onMounted(() => {
    store.dispatch('fetchSubsectors');
    resetForm();
});

async function sync() {
    loading.value = true;
    await corporatesService.syncSubsectors(id.value, form);

    loading.value = false;
    showModal.value = false;
    emit('synced')
}

function open(corporateId) {
    resetForm();
    subsectors.value = [];

    id.value = corporateId;
    showModal.value = true;
}

defineExpose({open});
</script>

<template>
    <b-modal
        v-model="showModal"
        modal-class="modal-w-md" :title="(id ? 'Edit' : 'Add') + ' Feature'"
    >
        <form class="form pb-5">
            <div class="form__item">
                <h5 class="heading5 heading5--secondary">LLM</h5>

                <select class="form-control--mid form-control" v-model="form.llm">
                    <option value="gpt-4o">GPT</option>
                    <option value="perplexity">PPX</option>
                </select>
            </div>

            <div class="form__item">
                <label><input type="checkbox" v-model="selectCategories"> Select Subcategories</label>
            </div>

            <div class="form__item" v-if="selectCategories">
                <h5 class="heading5 heading5--secondary">
                    Select Subsectors
                </h5>

                <VueMultiselect
                    v-model="subsectors"
                    placeholder="Select Subsectors"
                    :options="store.getters.subsectorsList"
                    select-label=""
                    deselect-label=""
                    multiple
                    label="name"
                    track-by="name"
                    class="multiselect-mid pl-2"
                />
            </div>
        </form>

        <template #modal-footer>
            <PrimaryButton
                :disabled="!canSync"
                :loading="loading"
                loadingCaption="Syncing..."
                @click="sync"
            />
        </template>
    </b-modal>
</template>

<style scoped>

</style>
